<template>
  <div>
    <div class="pover-right-con approve-dialog-detail">
      <p class="title">基本信息</p>
      <div class="form-list-info clearfix">
        <div class="item item-show">
          <span class="label">订单ID：</span>
          <p class="result">{{info.order_code || '--'}}</p>
        </div>
        <div class="item item-show">
          <span class="label">商机ID：</span>
          <p class="result">{{info.business_code || '--'}}</p>
        </div>
        <div class="item item-show">
          <span class="label">客户：</span>
          <p class="result">{{info.customer_name || '--'}}</p>
        </div>
        <div class="item item-show">
          <span class="label">项目：</span>
          <p class="result">{{info.project_name || '--'}}</p>
        </div>
        <div class="item item-show">
          <span class="label">物业类型：</span>
          <p class="result">{{info.house_type_name || '--'}}</p>
        </div>
        <div class="item item-show">
          <span class="label"> 楼栋：</span>
          <p class="result">{{info.building || '--'}}</p>
        </div>
        <div class="item item-show">
          <span class="label">单元：</span>
          <p class="result">{{info.unit || '--'}}</p>
        </div>
        <div class="item item-show">
          <span class="label">房号：</span>
          <p class="result">{{info.room_num || '--'}}</p>
        </div>
        <div class="item item-show">
          <span class="label"> 面积（㎡）：</span>
          <p class="result">{{info.area || '--'}}</p>
        </div>
        <div class="item item-show">
          <span class="label">优惠确认函：</span>
          <p class="result">{{info.preferential_code || '--'}}</p>
        </div>
      </div>
    </div>
    <el-form :model="data" :rules="itemRules" ref="itemAmount">
      <div class="pover-right-con approve-dialog-detail">
        <slot name="title"></slot>
        <div class="form-list-info clearfix">
          <div class="item item-left" :class="!!baseOrigin.subscription_amount && 'item-show'">
            <span class="label label-min">认购金额（元）：</span>
            <el-form-item prop="subscription_amount" class="lebel-con" v-if="!(!!baseOrigin.subscription_amount)">
              <el-input placeholder="请输入认购金额（元）" v-model="data.subscription_amount" clearable />
            </el-form-item>
            <p class="result" v-comma:{fixed:2}="baseOrigin.subscription_amount" v-else></p>
          </div>
          <div class="item item-left" :class="!!baseOrigin.room_total_amount && 'item-show'">
            <span class="label label-min">房屋总价（元）：</span>
            <el-form-item prop="room_total_amount" class="lebel-con" v-if="!(!!baseOrigin.room_total_amount)">
              <el-input placeholder="请输入房屋总价（元）" v-model="data.room_total_amount" clearable />
            </el-form-item>
            <p class="result" v-comma:{fixed:2}="baseOrigin.room_total_amount" v-else></p>
          </div>
          <div class="item item-left" :class="!!baseOrigin.brokerage && 'item-show'">
            <span class="label label-min">佣金（元）：</span>
            <el-form-item prop="brokerage" class="lebel-con" v-if="!(!!baseOrigin.brokerage)">
              <el-input placeholder="请输入佣金（元）" v-model="data.brokerage" clearable />
            </el-form-item>
            <p class="result" v-comma:{fixed:2}="baseOrigin.brokerage" v-else></p>
          </div>
          <div class="item item-left" :class="!!baseOrigin.discount_amount && 'item-show'">
            <span class="label label-min">优惠返佣（元）：</span>
            <el-form-item prop="discount_amount" class="lebel-con" v-if="!(!!baseOrigin.discount_amount)">
              <el-input placeholder="请输入优惠返佣（元）" v-model="data.discount_amount" clearable />
            </el-form-item>
            <p class="result" v-comma:{fixed:2}="baseOrigin.discount_amount" v-else></p>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import {getOrderApprove} from '@/api/custome';
import { validateMoney } from '@/utils/validate';
export default {
  name: 'OrderItem',
  props: {
    info: Object,
    orderId: Number
  },
  mounted () {
    this.initActuaPrice(this.orderId);
  },
  watch: {
    orderId (id, oldId) {
      if (id !== oldId) {
        this.initActuaPrice(id);
      }
      ['subscription_amount', 'room_total_amount', 'brokerage', 'discount_amount'].map(v => {
        this.$set(this.data, v, this.info[v]);
      })
    }
  },
  data () {
    return {
      baseOrigin: {},
      data: {
        subscription_amount: '',
        room_total_amount: '',
        brokerage: '',
        discount_amount: ''
      },
      itemRules: {
        subscription_amount: [
          { validator: validateMoney, name: '认购金额', trigger: 'blur', isEmpty: true }
        ],
        room_total_amount: [
          { validator: validateMoney, name: '房屋总价', trigger: 'blur', isEmpty: true }
        ],
        brokerage: [
          { validator: validateMoney, name: '佣金', trigger: 'blur', isEmpty: true }
        ],
        discount_amount: [
          { validator: validateMoney, name: '优惠返佣', trigger: 'blur', isEmpty: true }
        ]
      }
    }
  },
  beforeDestroy () {
    this.$refs.itemAmount && this.$refs.itemAmount.clearValidate();
  },
  methods: {
    async initActuaPrice (id) {
      if (!(!!id)) return null;
      try {
        const res = await getOrderApprove({
          order_id: id
        })
        this.baseOrigin = res || {};
        ['subscription_amount', 'room_total_amount', 'brokerage', 'discount_amount'].map(v => {
          this.$set(this.data, v, this.info[v]);
        })
      } catch (error) {
        this.$message.error(error.msg || '获取订单审批单信息错误');
      }
    },
    validate () {
      return new Promise(resolve => {
        this.$refs.itemAmount.validate(valid => {
          resolve({status: valid, data: this.data});
        })
      })
    }
  }
}
</script>
<style scoped lang="less">

.item .label.label-min{
  min-width: 111px !important;
  margin-left: -20px;
}
.item.item-show .label.label-min{
  min-width: initial !important;
  margin-left: 0;
}
.item.item-left{
  padding-right: 7% !important;
}
</style>
